import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/achat/facture`;

export const createFactureAchat = (data) => axios.post(`${API_BASE_URL}/create`, data);
export const saveFactureAchat = (payload) => axios.put(`${API_BASE_URL}/save`, payload);
export const getFactureAchat = (id) => axios.get(`${API_BASE_URL}/get/${id}`);
export const listFacturesAchat = (params) => axios.get(`${API_BASE_URL}/list`, { params });
export const getItemsInFactureAchat = (id) => axios.get(`${API_BASE_URL}/items/${id}`);
export const validateFactureAchat = (id) => axios.post(`${API_BASE_URL}/validate/${id}`);
export const unvalidateFactureAchat = (id) => axios.post(`${API_BASE_URL}/unvalidate/${id}`);


